var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8727 14.5736C33.0399 14.5736 31.4059 13.7107 30.352 12.3711C29.2982 13.7107 27.6641 14.5736 25.8314 14.5736H25.5207C23.688 14.5736 22.0539 13.7107 21 12.3711C19.9462 13.7107 18.3121 14.5736 16.4794 14.5736H16.1687C14.336 14.5736 12.7019 13.7107 11.6481 12.3711C10.5941 13.7107 8.96016 14.5736 7.12742 14.5736H6.81677C6.28619 14.5736 5.77284 14.4998 5.28467 14.3647V18.596H36.7156V14.3647C36.2274 14.4998 35.7141 14.5736 35.1835 14.5736H34.8727Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81656 12.1126H7.12721C8.94141 12.1126 10.4174 10.6367 10.4174 8.82245V6.41516H3.52637V8.82237C3.52637 10.6367 5.00236 12.1126 6.81656 12.1126Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8784 8.82237C12.8784 10.6366 14.3544 12.1126 16.1686 12.1126H16.4793C18.2935 12.1126 19.7695 10.6366 19.7695 8.82237V6.41516H12.8784V8.82237Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2305 8.82237C22.2305 10.6366 23.7065 12.1126 25.5207 12.1126H25.8313C27.6455 12.1126 29.1215 10.6366 29.1215 8.82237V6.41516H22.2305V8.82237Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5824 6.41516V8.82237C31.5824 10.6366 33.0584 12.1126 34.8726 12.1126H35.1832C36.9974 12.1126 38.4734 10.6366 38.4734 8.82237V6.41516H31.5824Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4898 3.95423L35.2575 0.364301C35.1157 0.136172 34.8706 0 34.6019 0H7.39792C7.12927 0 6.88416 0.136172 6.74233 0.364301L4.51001 3.95423H37.4898Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28455 21.0569H24.6409V34.4282H5.28455V21.0569Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6409 42V36.8892H5.2845V39.539H2.02441C1.34487 39.539 0.793945 40.0899 0.793945 40.7695C0.793945 41.449 1.34487 42 2.02441 42H24.6409Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7155 39.539V21.0569H27.1018V42H39.9755C40.6551 42 41.206 41.449 41.206 40.7695C41.206 40.0899 40.6551 39.539 39.9755 39.539H36.7155Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.d71f504b8710a0071cdb6444509e456e.svg";
export { ForwardRef as ReactComponent };